import React from 'react';
import styled from 'styled-components';

const TechChips = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.25rem 0 1rem 0;
  padding: 0;
  list-style: none;
`;

const TechChip = styled.li`
  background: rgba(0,0,0,0.04);
  color: #111;
  padding: 0.28rem 0.6rem;
  border-radius: 999px;
  font-size: 0.95rem;
  font-weight: 500;
`;

const TECH_ITEMS = [
  'Python', 'Go', 'JVM (Kotlin & Java)', 'Swift',
  'FastAPI', 'SQLAlchemy', 'Pydantic',
  'PostgreSQL', 'Redis', 'gRPC', 'Protobuf',
  'Docker', 'Kubernetes', 'Nomad',
  'Terraform',
  'AWS', 'GCP',
];

export default function TechExperience() {
  return (
    <TechChips>
      {TECH_ITEMS.map(item => <TechChip key={item}>{item}</TechChip>)}
    </TechChips>
  );
}
